import { render, staticRenderFns } from "./ShipmentReceipt.vue?vue&type=template&id=1acaf976&scoped=true"
import script from "./ShipmentReceipt.vue?vue&type=script&lang=js"
export * from "./ShipmentReceipt.vue?vue&type=script&lang=js"
import style0 from "./ShipmentReceipt.vue?vue&type=style&index=0&id=1acaf976&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acaf976",
  null
  
)

export default component.exports